import React, { useEffect, useState } from 'react';
import { API_URL, ENDPOINTS, getData } from '../../constants/api';
import PatientDetail from './PatientInfo';
import PatientTabs from './PatientTabs';
import { updateColumn } from '../../constants/functions';

function AppointmentsList({ appointments, onSelect }) {
  console.log('appointments:', appointments);
  const getBadgeClass = (status) => {
    switch (status.toLowerCase()) {
      case 'scheduled':
        return 'bg-warning text-dark'; // warning badge with dark text for contrast
      case 'process':
        return 'bg-info text-dark';
      case 'canceled':
        return 'bg-danger';
      case 'completed':
        return 'bg-success';
      default:
        return 'bg-secondary';
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">Pending Appointments</h4>
      </div>
      <ul className="list-group">
        {appointments &&
          appointments.length > 0 &&
          appointments.map((appt) => (
            <li
              key={appt.ID}
              className="list-group-item"
              onClick={() => onSelect(appt.ID)}
              style={{ cursor: 'pointer' }}
            >
              <div className="fw-bold">
                Name: {appt.Patient} —{' '}
                <span className={`badge ${getBadgeClass(appt.Status)}`}>
                  {appt.Status}
                </span>
                &nbsp; &nbsp; &nbsp;
                {appt.Status === 'scheduled' && (
                  <button
                    className={`btn btn-danger btn-sm`}
                    onClick={(e) =>
                      updateColumn(
                        e,
                        `updatecolumn/caafi_appointment/${appt.ID}/status/process`
                      )
                    }
                  >
                    Call
                  </button>
                )}
              </div>
              <div className="text-muted">
                Age: <strong>{appt.Age}</strong> — Date:{' '}
                <strong>{appt['Appointment Date']}</strong> -Type:{' '}
                <strong>{appt.Type}</strong>
              </div>
            </li>
          ))}
      </ul>
    </div>
  );
}

export default function DoctorPortal() {
  const [appointments, setAppointments] = useState([]);

  useEffect(() => {
    const fetchAppointments = async () => {
      const url = `${API_URL}/${ENDPOINTS.SYS}/getlink/Today-Pending-Appointments`;
      try {
        const appointmentsResult = await getData(url);
        // console.log('appointmentsResult:', appointmentsResult);
        setAppointments(appointmentsResult.report);
      } catch (err) {
        console.error(err);
      }
    };

    fetchAppointments();
  }, []);
  const [selectedAppointment, setSelectedAppointment] = useState(null);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-3">
          <AppointmentsList
            appointments={appointments}
            onSelect={setSelectedAppointment}
          />
        </div>
        <div className="col-9">
          <PatientTabs appointmentId={selectedAppointment} />
        </div>
      </div>
    </div>
  );
}
